// extracted by mini-css-extract-plugin
export default {"p_tye":"cff478f869","slcted":"a7e63fa3ea","slc_color":"_92a143738a","item_p":"_7b88cd6c4a","r0":"f770d93f7a"};